import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { IncidentsPageComponent } from './incidents-page.component';

const routes: Routes = [
  { path: '', component: IncidentsPageComponent, data: { title: 'Incidents' } },
  { path: ':mine', component: IncidentsPageComponent, data: { title: 'Incidents' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IncidentsPageRoutingModule {}

@NgModule({
  imports: [
    IncidentsPageRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [IncidentsPageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IncidentsPageModule {}
